export default __webpack_public_path__ + "static/media/eye-solid.6dd055f9.svg";